<template lang="pug">
  .desktop-teacher
    v-tabs(
      v-model="tab"
      :background-color="$vuetify.theme.dark ? '#303030' : 'white'"
      :color="$vuetify.theme.dark ? 'white' : 'secondary'"
    ).mb-3
      v-tabs-slider

      v-tab(
        v-for="t in tabs"
        :key="t.id"
        :href="`#tab-${t.id}`"
      ) {{ t.name }}
    .loader-target
    v-slide-y-reverse-transition(mode="out-in")
      v-row(v-if="tab === 'tab-1'"  key="1")
        v-slide-y-reverse-transition(mode="out-in" leave-absolute)
          v-col(
            v-if="!activeCourses.length && !$loader.isLoading" cols="12" class="pa-5 text-center")
            | Нет активных курсов

        v-col(
          xl="3" lg="4" md="6" cols="12"
          v-for="(course, i) in activeCourses"
          :key="course.id"
        )
          course-card.mt-2(
            :course="course"
            editable outlined
          )

      v-row(v-if="tab === 'tab-2'" key="2")
        v-col(
          v-if="!draftCourses.length && !$loader.isLoading" cols="12" class="pa-5 text-center")
          | У Вас нет черновиков
          v-btn.ml-2(
            :to="{ name: 'CourseCreate'}" color="primary" rounded depressed) Создать курс
        v-col(
          xl="3" lg="4" md="6" cols="12"
          v-for="(course, i) in draftCourses"
          v-if="course.id"
          :key="course.id"
        )
          course-card.mt-2(
            :course="course"
            outlined
            editable
          )
</template>

<script>
import CourseService from '@/services/API/CourseService';
import CourseCard from '@/modules/Courses/components/CourseCard.vue';

import { STATUSES } from '@/modules/CourseManagement/constants';

export default {
  name: 'DesktopTeacher',
  components: {
    CourseCard,
  },
  data: () => ({
    tab: 0,
    tabs: [
      { id: 1, name: 'Активные' },
      { id: 2, name: 'Черновики' },
    ],
    activeCourses: [],
    draftCourses: [],

    STATUSES,
  }),
  watch: {
    tab(val) {
      if (val === 'tab-1') this.getCourseList(this.activeCourses, STATUSES.active);
      if (val === 'tab-2') this.getCourseList(this.draftCourses, STATUSES.draft);
    },
  },
  methods: {
    getCourseList(coursesArray) {
      const params = {};
      params['search[course_authors]'] = this.$user.data.id;
      params.expand = 'organizations,lessons,edit,type_activity_name,prior_records,course_units_count';

      this.$loader.start({ target: true });
      CourseService.index({ ...params })
        .then(({ items }) => {
          if (!coursesArray.length) coursesArray.push(...items);
          this.$loader.stop();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  .v-tab.v-tab {
    font-weight: 700;
  }
</style>
